import { render } from "./VODitemContent.vue?vue&type=template&id=61552422"
import script from "./VODitemContent.vue?vue&type=script&lang=js"
export * from "./VODitemContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__